import type { MouseEvent } from "react";
import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { InstructorIcon } from "../../icons/InstructorIcon";
import { Column } from "../../misc/Column";
import { Row } from "../../misc/Row";
import type { Course } from "../../providers/coursesProvider";

export function CourseMobileListItem(props: {
  branchName?: string;
  course: Course;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { branchName, course, onClick } = props;
  const theme = useTheme();
  const status = course.start < DateTime.now() ? "Aktiv" : "Geplant";
  const attendees =
    typeof course.maxAttendees === "number"
      ? `${course.numAttendees}/${course.maxAttendees} Teilnehmer`
      : `${course.numAttendees} Teilnehmer`;
  const details = [branchName, `${course.start.toFormat("dd.MM.yyyy")}–${course.end.toFormat("dd.MM.yyyy")}`].filter(
    Boolean,
  );

  return (
    <ButtonBase
      component="div"
      onClick={onClick}
      role="button"
      tabIndex={0}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
      }}
    >
      <Column sx={{ gap: 0.5, minWidth: 0 }}>
        <Row sx={{ alignItems: "flex-start", gap: 1.25, minWidth: 0 }}>
          <Box
            sx={{
              alignItems: "center",
              backgroundColor: theme.palette.action.hover,
              borderRadius: "50%",
              color: theme.palette.text.secondary,
              display: "flex",
              flexShrink: 0,
              height: 40,
              justifyContent: "center",
              width: 40,
            }}
          >
            <InstructorIcon fontSize="small" />
          </Box>
          <Column sx={{ gap: 0.25, minWidth: 0 }}>
            <Typography variant="body1" sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
              {course.name}
            </Typography>
            <Typography variant="caption" color="text.secondary" noWrap>
              {details.join(" · ")}
            </Typography>
          </Column>
        </Row>
        <Row sx={{ alignItems: "center", justifyContent: "space-between", gap: 1 }}>
          <Typography variant="caption" color="text.secondary" noWrap>
            {course.numEvents} Termine · {attendees}
          </Typography>
          <Row sx={{ alignItems: "center", flexShrink: 0, gap: 0.75 }}>
            <Box
              sx={{
                backgroundColor: status === "Aktiv" ? "success.main" : "background.paper",
                border: `2px solid ${theme.palette.divider}`,
                borderRadius: "50%",
                boxSizing: "border-box",
                height: 12,
                width: 12,
              }}
            />
            <Typography variant="caption" color="text.secondary">
              {status}
            </Typography>
          </Row>
        </Row>
      </Column>
    </ButtonBase>
  );
}
